import type { ConfiguracionPrecios } from "./precios";

export type PreciosEditables = Record<keyof ConfiguracionPrecios, string>;
export type PreferenciasVenta = { activo: boolean; personalizar: boolean; precios: PreciosEditables | null };
export const CLAVE_MODO_VENTA = "trufamilia.ventas.modo-excepcional.v1";
export const CLAVES_PRECIOS = ["precioIndividualCentavos", "precioPaqueteCentavos", "precioLotusIndividualCentavos", "precioLotusPaqueteCentavos"] as const;

export function leerPreferenciasVenta(): PreferenciasVenta {
  const defecto = { activo: false, personalizar: false, precios: null };
  try {
    const guardado = JSON.parse(localStorage.getItem(CLAVE_MODO_VENTA) || "null");
    if (!guardado || typeof guardado.activo !== "boolean" || typeof guardado.personalizar !== "boolean") return defecto;
    const precios = guardado.precios && CLAVES_PRECIOS.every(clave => typeof guardado.precios[clave] === "string") ? guardado.precios : null;
    return { activo: guardado.activo, personalizar: guardado.personalizar, precios };
  } catch { return defecto; }
}

export function editarPrecios(precios: ConfiguracionPrecios): PreciosEditables {
  return Object.fromEntries(CLAVES_PRECIOS.map(clave => [clave, (precios[clave] / 100).toFixed(2)])) as PreciosEditables;
}

export function preciosEnCentavos(precios: PreciosEditables): ConfiguracionPrecios | null {
  const valores = CLAVES_PRECIOS.map(clave => Math.round(Number(precios[clave]) * 100));
  if (valores.some(valor => !Number.isSafeInteger(valor) || valor < 1 || valor > 1000000)) return null;
  return Object.fromEntries(CLAVES_PRECIOS.map((clave, indice) => [clave, valores[indice]])) as ConfiguracionPrecios;
}
